/* eslint-disable @typescript-eslint/no-explicit-any */
import { http } from '@/services/api/http';
import { dataV3DetailSuppliersRecordPost } from '@/services/swagger/customs/CustomsDataV3Service';
import {
  getCompanyTimeLinePost,
  getMergeCompanyListGet,
  getOwnRecordDetailPost,
  getSupplierBaseInfoPost,
  getSupplierExportRecordV3Post,
  getSuppliersMonthStatisticsPost,
  listCompanyAreaStatisticsPost,
  listCompanyHsCodeStatisticsPagePost,
  recordDetailPost,
} from '@/services/swagger/customs/EaseSourcingService';
import {
  easeSourcingCompanyDetailGet,
  easeSourcingIdListPost,
} from '@/services/swagger/globalSearch/GlobalAuthService';

const baseUrl = `/es/api/pub/session/global-search/`;
type CompnayFun = typeof easeSourcingCompanyDetailGet;

type MergeCompanyFun = typeof getMergeCompanyListGet;
/*
 * 买家工具后端转发了 easeSourcingCompanyDetailGet 接口
 * @param payload
 * @param options
 * @returns
 */
export const getSupplierDetail: CompnayFun = async (payload, options) => {
  const params = payload;
  const result = await http.request<any>({
    url: `${baseUrl}company-detail`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
};
/**
 * 获取合并公司的列表
 * @param payload
 * @param options
 * @returns
 */
export const getMergeCompanyList: MergeCompanyFun = async (payload, options) => {
  const params = payload;
  const result = await http.request<any>({
    url: `${baseUrl}merge-company-list`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
};

/**
 * 统计数据
 */
type ExportOverviewFun = typeof dataV3DetailSuppliersRecordPost;
export const getExportOverview: ExportOverviewFun = async (payload, options) => {
  const data = payload;

  const result = await http.request<any>({
    url: `${baseUrl}export-overview`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
};

/**
 * 
 * {
    "/api/biz/session/global-search/company-detail": {
        "targetUrl": "http://sirius-it-global-search-dev.cowork-i.netease.com/api/auth/global/ease/sourcing/companyDetail",
        "route": "globalSearchProxy"
    },
    "/api/biz/session/global-search/v1/detail-new": {
        "targetUrl": "http://sirius-it-global-search-dev.cowork-i.netease.com/api/globalSearch/v1/detail/new",
        "route": "globalSearchProxy"
    },
    "/api/biz/session/global-search/v3/buyers-base": {
        "targetUrl": "http://sirius-ciq-data-server-dev.cowork-i.netease.com/api/biz/customs/data/v3/detail/buyers/base",
        "route": "ciqDataProxy"
    },
    "/api/biz/session/global-search/v3/buyers-timeline": {
        "targetUrl": "http://sirius-ciq-data-server-dev.cowork-i.netease.com/api/auth/customs/easeSourcing/v3/detail/buyers/timeline",
        "route": "ciqDataProxy"
    },
    "/api/biz/session/global-search/merge-company-list": {
        "targetUrl": "http://sirius-ciq-data-server-dev.cowork-i.netease.com/api/auth/customs/easeSourcing/detail/get/mergeCompanyList",
        "route": "ciqDataProxy"
    },
    "/api/biz/session/global-search/suppliers-base": {
        "targetUrl": "http://sirius-ciq-data-server-dev.cowork-i.netease.com/api/auth/customs/easeSourcing/detail/suppliers/base",
        "route": "ciqDataProxy"
    },
    "/api/biz/session/global-search/suppliers-statistics": {
        "targetUrl": "http://sirius-ciq-data-server-dev.cowork-i.netease.com/api/auth/customs/easeSourcing/detail/suppliers/statistics",
        "route": "ciqDataProxy"
    },
    "/api/biz/session/global-search/v3/area-statistics": {
        "targetUrl": "http://sirius-ciq-data-server-dev.cowork-i.netease.com/api/auth/customs/easeSourcing/v3/detail/hscode/statistics/page",
        "route": "ciqDataProxy"
    },
    "/api/biz/session/global-search/v3/auth-suppliers-record": {
        "targetUrl": "http://sirius-ciq-data-server-dev.cowork-i.netease.com/api/auth/customs/easeSourcing/v3/detail/area/statistics",
        "route": "ciqDataProxy"
    },
    "/api/biz/session/global-search/own-record-detail": {
        "targetUrl": "http://sirius-ciq-data-server-dev.cowork-i.netease.com/api/auth/customs/easeSourcing/own/record/detail",
        "route": "ciqDataProxy"
    },
    "/api/biz/session/global-search/record-detail": {
        "targetUrl": "http://sirius-ciq-data-server-dev.cowork-i.netease.com/api/auth/customs/easeSourcing/record/detail",
        "route": "ciqDataProxy"
    },
    "/api/biz/session/global-search/suppliers-record": {
        "targetUrl": "http://sirius-ciq-data-server-dev.cowork-i.netease.com/api/auth/customs/easeSourcing/v3/detail/suppliers/record",
        "route": "ciqDataProxy"
    }
}


 * /
 * /**
 * 买家地图list数据
 * @param payload
 * @param options
 * @returns
 */
export const getBuyerMapList: typeof listCompanyAreaStatisticsPost = async (payload, options) => {
  const data = payload;
  const result = await http.request<any>({
    url: `${baseUrl}v3/auth-suppliers-record`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
};
/**
 *
 * @param payload
 * @param options
 * @returns
 */
export const getTimeLine: typeof getCompanyTimeLinePost = async (payload, options) => {
  const data = payload;
  const result = await http.request<any>({
    url: `${baseUrl}v3/buyers-timeline`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
};
/**
 * 获取供应商出口统计的数据
 * @param payload
 * @param options
 * @returns
 */
export const getSuppliersBase: typeof getSupplierBaseInfoPost = async (payload, options) => {
  const data = payload;
  const result = await http.request<any>({
    url: `${baseUrl}suppliers-base`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
};
/**
 * 供应商记录（biz）
 */
export const getBizSuppliersRecord: typeof dataV3DetailSuppliersRecordPost = async (payload: any, options?: any) => {
  const data = payload;
  const result = await http.request<any>({
    url: `${baseUrl}v3/biz-suppliers-record`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
};
/**
 * 供应商统计
 * 每日导出统计折线图
 */
export const getSuppliersStatistics: typeof getSuppliersMonthStatisticsPost = async (payload, options) => {
  const data = payload;
  const result = await http.request<any>({
    url: `${baseUrl}suppliers-statistics`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
};

/**
 * 统计页面-买家地图
 */
export const getStatisticsPage: typeof listCompanyHsCodeStatisticsPagePost = async (payload, options) => {
  const data = payload;
  const result = await http.request<any>({
    url: `${baseUrl}v3/statistics-page`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
};

/**
 * 获取海关出口交易记录详情
 */
export const getSupplierTransctionRecordList: typeof getSupplierExportRecordV3Post = async (payload, options) => {
  const data = payload;
  const result = await http.request<any>({
    url: `${baseUrl}suppliers-record`,
    method: 'post',
    data,
    ...options,
  });
  return result.data;
};

export const getSupplierIdList: typeof easeSourcingIdListPost = async (payload, options) => {
  const data = payload;

  const result = await http.request<any>({
    // api/biz/session/global-search/sourcing-id-list
    url: `${baseUrl}sourcing-id-list`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
};
/**
 * 供应商记录（auth）
 */
export const getAuthSuppliersRecord = async (payload: any, options?: any) => {
  const data = payload;
  const result = await http.request<any>({
    url: `${baseUrl}v3/auth-suppliers-record`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
};

/**
 * sourceType === 0 时调用
 * 自有记录详情
 */
export const getOwnRecordDetail: typeof getOwnRecordDetailPost = async (payload, options) => {
  const data = payload;
  const result = await http.request<any>({
    url: `${baseUrl}own-record-detail`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
};

/**
 * 记录详情 sourceType === 1 时调用
 */
export const getRecordDetail: typeof recordDetailPost = async (payload, options) => {
  const params = payload;
  const result = await http.request<any>({
    url: `${baseUrl}record-detail`,
    method: 'post',
    params,
    data: params,
    ...options,
  });

  return result.data;
};
